import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExternalLinkIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <path d="M9 11H2a2.006 2.006 0 0 1-2-2V2a2.006 2.006 0 0 1 2-2h7a2.006 2.006 0 0 1 2 2v7a2.006 2.006 0 0 1-2 2ZM4 2v1h2.6L1.3 8.3l1.4 1.4L8 4.4V7h1V2Z" fill={this.getColor()} fillRule="evenodd"/>
    </g>
  ]
  getViewBox = () => '0 0 11 11'
}
